import { ApiData, Entity, EntityId } from 'entities-next/common'

export type Subspace = Entity & CommonSubspaceData

export type CommonSubspaceData = {
  readonly userId: EntityId
  readonly spaceId: EntityId
  readonly name: string
  readonly description: string
}

export type IdIndexedSubspace = {
  readonly [subspaceId: number]: Subspace
}

export type ApiSubspace = Subspace

export type ApiSubspaceData = ApiData<ApiSubspace>

export const SUBSPACE_CACHE_STORE_ID = 'subspace'
